(function (window, document) {
  'use strict';

  function parseJson(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function findOptionIndex(names, expression) {
    return names.findIndex(function (name) {
      return expression.test(String(name || '').trim());
    });
  }

  function uniqueValues(values) {
    return values.filter(function (value, index) {
      return value !== null && value !== undefined && values.indexOf(value) === index;
    });
  }

  function initialize($) {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-scrubz-complete-set]'));

    roots.forEach(function (root) {
      if (root.getAttribute('data-cts-initialized') === 'true') return;
      root.setAttribute('data-cts-initialized', 'true');

      var mainNames = parseJson(root.getAttribute('data-main-option-names'), []);
      var mainVariants = parseJson(root.getAttribute('data-main-variants'), []);
      var mainColorIndex = findOptionIndex(mainNames, /colou?r/i);
      var mainSelector = document.querySelector(root.getAttribute('data-main-selector'));
      var items = [];

      Array.prototype.forEach.call(root.querySelectorAll('[data-scrubz-set-item]'), function (element) {
        var data = parseJson(element.getAttribute('data-product-json'), null);
        if (!data || !Array.isArray(data.options) || !Array.isArray(data.variants)) return;

        var item = {
          element: element,
          data: data,
          colorIndex: findOptionIndex(data.options, /colou?r/i),
          sizeIndex: findOptionIndex(data.options, /size/i),
          fixedOptions: {},
          controls: [],
          image: element.querySelector('[data-cts-image]'),
          placeholder: element.querySelector('[data-cts-image-placeholder]'),
          colorWrap: element.querySelector('[data-cts-current-color-wrap]'),
          colorText: element.querySelector('[data-cts-current-color]'),
          optionsContainer: element.querySelector('[data-cts-options]'),
          price: element.querySelector('[data-cts-price]'),
          message: element.querySelector('[data-cts-message]'),
          button: element.querySelector('[data-cts-add]'),
          buttonLabel: element.querySelector('[data-cts-add-label]'),
          busy: false
        };

        if (item.data.variants.length === 0) return;

        item.data.variants.forEach(function (variant) {
          variant.options = Array.isArray(variant.options) ? variant.options : [];
        });

        var availableVariants = item.data.variants.filter(function (variant) {
          return variant.available === true;
        });

        var optionIndexes = item.data.options.map(function (name, index) {
          return index;
        });
        optionIndexes.sort(function (a, b) {
          var priority = function (index) {
            if (index === item.colorIndex) return 0;
            if (index === item.sizeIndex) return 1;
            return 2;
          };
          return priority(a) - priority(b) || a - b;
        });

        optionIndexes.forEach(function (index) {
          var name = item.data.options[index];
          var values = uniqueValues(availableVariants.map(function (variant) {
            return variant.options[index];
          }));

          if (String(name).toLowerCase() === 'title' && values.length === 1) {
            item.fixedOptions[index] = values[0];
            return;
          }

          var type = index === item.colorIndex ? 'color' : (index === item.sizeIndex ? 'size' : 'option');
          var placeholder = type === 'color' ? 'Select a Color' : (type === 'size' ? 'Select a Size' : 'Select a ' + name);
          var label = document.createElement('label');
          var labelText = document.createElement('span');
          var select = document.createElement('select');
          var placeholderOption = document.createElement('option');

          label.className = 'scrubz-complete-set__option';
          labelText.className = 'scrubz-complete-set__sr-only';
          labelText.textContent = name;
          select.setAttribute('data-cts-option', '');
          select.setAttribute('data-option-index', String(index));
          select.setAttribute('data-option-type', type);
          select.setAttribute('aria-label', name + ' for ' + data.title);
          placeholderOption.value = '';
          placeholderOption.textContent = placeholder;
          select.appendChild(placeholderOption);
          label.appendChild(labelText);
          label.appendChild(select);
          item.optionsContainer.appendChild(label);
          item.controls.push({ index: index, name: name, type: type, select: select, placeholder: placeholder });
        });

        refreshOptions(item);
        item.controls.forEach(function (control) {
          if (control.type !== 'option') return;
          var values = uniqueValues(availableVariants.map(function (variant) {
            return variant.options[control.index];
          }));
          if (values.length === 1) control.select.value = values[0];
        });

        refreshOptions(item);
        updateItem(item);
        items.push(item);
      });

      function currentMainColor() {
        if (!mainSelector || mainColorIndex < 0) return null;
        var selectedId = mainSelector.value;
        var selected = mainVariants.find(function (variant) {
          return String(variant.id) === String(selectedId);
        });
        return selected && selected.options ? selected.options[mainColorIndex] : null;
      }

      function synchronizeColor(color) {
        if (color === null || color === undefined || color === '') return;
        items.forEach(function (item) {
          if (item.colorIndex < 0) return;
          var colorControl = item.controls.find(function (control) {
            return control.index === item.colorIndex;
          });
          if (!colorControl) return;
          var exactAvailableMatch = item.data.variants.some(function (variant) {
            return variant.available === true &&
              variant.options[item.colorIndex] === color;
          });
          if (!exactAvailableMatch) return;
          colorControl.select.value = color;
          clearMessage(item);
          refreshOptions(item);
          updateItem(item);
        });
      }

      var lastMainColor;
      function checkMainColor() {
        var color = currentMainColor();
        if (color === null || color === undefined || color === lastMainColor) return;
        lastMainColor = color;
        synchronizeColor(color);
      }

      $(root).on('change.scrubzCompleteSet', '[data-cts-option]', function () {
        var itemElement = this.closest('[data-scrubz-set-item]');
        var item = items.find(function (candidate) {
          return candidate.element === itemElement;
        });
        if (!item) return;
        clearMessage(item);
        refreshOptions(item);
        updateItem(item);
      });

      $(root).on('click.scrubzCompleteSet', '[data-cts-add]', function () {
        var button = this;
        var item = items.find(function (candidate) {
          return candidate.button === button;
        });
        if (!item || item.busy) return;

        var missing = item.controls.find(function (control) {
          return !control.select.value;
        });
        if (missing) {
          showMessage(item, missing.type === 'size' ? 'Please select a size.' : (missing.type === 'color' ? 'Please select a color.' : 'Please select a ' + missing.name + '.'));
          missing.select.focus();
          return;
        }

        var variant = getExactVariant(item);
        if (!variant || variant.available !== true) {
          showMessage(item, 'This combination is unavailable. Please choose another option.');
          updateItem(item);
          return;
        }

        addRelatedVariant(root, item, variant);
      });

      if (mainSelector && mainColorIndex >= 0) {
        $(mainSelector).on('change.scrubzCompleteSet', checkMainColor);
        checkMainColor();
        var mainColorTimer = window.setInterval(function () {
          if (!root.isConnected) {
            window.clearInterval(mainColorTimer);
            $(mainSelector).off('.scrubzCompleteSet', checkMainColor);
            return;
          }
          checkMainColor();
        }, 300);
      }
    });
  }

  function getSelectedOptions(item, omittedIndex, overrides) {
    var selected = Object.assign({}, item.fixedOptions, overrides || {});
    item.controls.forEach(function (control) {
      if (control.index !== omittedIndex && control.select.value) {
        selected[control.index] = control.select.value;
      }
    });
    return selected;
  }

  function matchesSelection(variant, selected) {
    return Object.keys(selected).every(function (index) {
      return variant.options[Number(index)] === selected[index];
    });
  }

  function matchingVariants(item, omittedIndex, overrides, ignoredIndexes) {
    var selected = getSelectedOptions(item, omittedIndex, overrides);
    (ignoredIndexes || []).forEach(function (index) {
      delete selected[index];
    });
    return item.data.variants.filter(function (variant) {
      return variant.available === true && matchesSelection(variant, selected);
    });
  }

  function refreshOptions(item) {
    var passes = item.controls.length + 1;
    while (passes > 0) {
      passes -= 1;
      var changed = false;
      item.controls.forEach(function (control) {
        var previous = control.select.value;
        var matching = control.type === 'color'
          ? item.data.variants
          : matchingVariants(item, control.index);
        var values = uniqueValues(matching.map(function (variant) {
          return variant.options[control.index];
        }));
        var nextValue = values.indexOf(previous) !== -1 ? previous : '';
        while (control.select.options.length > 1) control.select.remove(1);
        values.forEach(function (value) {
          var option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          control.select.appendChild(option);
        });
        control.select.value = nextValue;
        control.select.disabled = values.length === 0;
        if (previous !== nextValue) changed = true;
      });
      if (!changed) break;
    }
  }

  function getExactVariant(item) {
    var selected = getSelectedOptions(item, null);
    if (Object.keys(selected).length !== item.data.options.length) return null;
    return item.data.variants.find(function (variant) {
      return variant.available === true && variant.options.length === item.data.options.length && matchesSelection(variant, selected);
    }) || null;
  }

  function updateItem(item) {
    var exactVariant = getExactVariant(item);
    var previewVariants = matchingVariants(item, null);
    var hasSelection = item.controls.some(function (control) {
      return control.select.value !== '';
    });
    var previewVariant = exactVariant || (hasSelection || !item.data.featuredImage ? previewVariants[0] : null) || null;
    var hasVariants = item.data.variants.some(function (variant) {
      return variant.available === true;
    });
    var missingControl = item.controls.some(function (control) {
      return !control.select.value;
    });

    if (item.colorIndex >= 0 && item.colorWrap && item.colorText) {
      var colorControl = item.controls.find(function (control) {
        return control.index === item.colorIndex;
      });
      var selectedColor = colorControl ? colorControl.select.value : '';
      item.colorWrap.hidden = !selectedColor;
      item.colorText.textContent = selectedColor;
    }

    if (item.price) {
      if (exactVariant) {
        item.price.textContent = exactVariant.formattedPrice || '';
      } else if (previewVariants.length && previewVariants.every(function (variant) {
        return variant.formattedPrice === previewVariants[0].formattedPrice;
      })) {
        item.price.textContent = previewVariants[0].formattedPrice || '';
      } else {
        item.price.textContent = previewVariants.length ? 'Select options' : 'Unavailable';
      }
    }

    if (previewVariant || item.data.featuredImage || hasSelection) {
      var imageVariant = exactVariant && exactVariant.image
        ? exactVariant
        : (previewVariant && previewVariant.image ? previewVariant : null);

      if (!imageVariant && item.colorIndex >= 0) {
        var selectedColorControl = item.controls.find(function (control) {
          return control.index === item.colorIndex;
        });
        if (selectedColorControl && selectedColorControl.select.value) {
          var imageOptions = getSelectedOptions(item, item.sizeIndex);
          imageVariant = item.data.variants.find(function (variant) {
            return Boolean(variant.image) && matchesSelection(variant, imageOptions);
          }) || null;
        }
      }

      var imageUrl = imageVariant ? imageVariant.image : item.data.featuredImage;
      var imageSrcset = imageVariant ? imageVariant.imageSrcset : item.data.featuredImageSrcset;
      if (imageUrl) {
        if (!item.image) {
          item.image = document.createElement('img');
          item.image.className = 'scrubz-complete-set__image';
          item.image.setAttribute('data-cts-image', '');
          item.image.loading = 'lazy';
          item.image.decoding = 'async';
          item.image.alt = item.data.title || '';
          var imageLink = item.element.querySelector('[data-cts-image-link]');
          if (item.placeholder) item.placeholder.remove();
          if (imageLink) imageLink.appendChild(item.image);
        }
        item.image.src = imageUrl;
        if (Array.isArray(imageSrcset) && imageSrcset.length) {
          item.image.srcset = imageSrcset.map(function (url, index) {
            return url + ' ' + [240, 360, 480, 640][index] + 'w';
          }).join(', ');
        } else {
          item.image.removeAttribute('srcset');
        }
      }
    }

    if (!hasVariants) {
      item.button.disabled = true;
      item.buttonLabel.textContent = 'Unavailable';
      showMessage(item, 'This product is currently unavailable.');
      return;
    }

    item.buttonLabel.textContent = 'ADD TO CART';
    item.button.disabled = item.busy || (!exactVariant && (!missingControl || previewVariants.length === 0));
  }

  function clearMessage(item) {
    if (!item.message) return;
    item.message.textContent = '';
    item.message.hidden = true;
  }

  function showMessage(item, message) {
    if (!item.message) return;
    item.message.textContent = message;
    item.message.hidden = false;
  }

  function addRelatedVariant(root, item, variant) {
    var button = item.button;
    item.busy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    clearMessage(item);

    window.fetch(root.getAttribute('data-cart-add-url'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    }).then(function (response) {
      return response.json().then(function (result) {
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item to the cart.');
        return result;
      });
    }).then(function () {
      showMessage(item, 'Added to cart.');
      if (window.geckoShopify && typeof window.geckoShopify.onCartUpdate === 'function') {
        try {
          window.geckoShopify.onCartUpdate(1, 1, item.data.id);
        } catch (error) {
          // The item was added successfully even if the theme cart refresh hook is unavailable.
        }
      }
    }).catch(function (error) {
      showMessage(item, error.message || 'Unable to add this item to the cart.');
    }).finally(function () {
      item.busy = false;
      button.removeAttribute('aria-busy');
      updateItem(item);
    });
  }

  function waitForThemeJQuery(attempt) {
    var themeJQuery = window.jQuery_T4NT;
    if (themeJQuery) {
      themeJQuery(function ($) {
        initialize($);
      });
      return;
    }
    if (attempt < 40) window.setTimeout(function () {
      waitForThemeJQuery(attempt + 1);
    }, 50);
  }

  waitForThemeJQuery(0);
})(window, document);
